module.exports = __webpack_public_path__ + "static/img/hzhb12.bede710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb12.png
// module id = CBhl
// module chunks = 0